<template>
	<div class="page main-page">
		<!-- <div class="title font34">数学同步学</div> -->
		<van-swipe class="my-swipe" :autoplay="3000" indicator-color="white" v-if="swiperImg.length">
			<van-swipe-item
				v-for="(item, index) in swiperImg"
				:key="`a${index}`"
				@click="swiperDetail(item.url, item.title)"
			>
				<div class="swiper-img">
					<van-image class="img" width="100%" height="100%"  :src="item.image" />
				</div>
			</van-swipe-item>
		</van-swipe>

		<ul class="main-nav df-sb">
			<li v-for="item in modulelist" :key="item.id+'icon'" @click="moduleNav(item)"> 
				<div class="nav-icon">
					<van-image width="100%"  :src="item.icon" />
				</div>
				<!-- <div class="nav-text">{{item.name}}</div> -->
			</li>
			
		</ul>
		<div class="course-learn">
			<div class="item-header">
				<div class="header-left">
					<img style="width: 0.57rem" :src="icon1" alt="" />
					<img style="width: 1.58rem; margin-left: 0.2rem" :src="icon2" alt="" />
				</div>
				<div class="header-right mCG font24" @click="showPicker = true">
					切换版本
					<i class="iconfont icon-fanhui"></i>
				</div>
			</div>
			<courseList :courseData="courseData" v-if="courseData.length"></courseList>
		</div>
		<van-popup v-model="showPicker" position="bottom">
			<van-picker show-toolbar :columns="columns" @cancel="showPicker = false" @confirm="onChange" />
		</van-popup>
		<!-- <van-picker v-model="showPicker" :columns="columns" @change="onChange" /> -->
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import { setSourceUrl } from '@/utils/public';
import courseList from '@/components/courseList.vue';

export default {
	name: 'mainPage',
	components: {
		courseList
	},
	computed: {
		...mapGetters({
			swiperImg: 'mainIndex/getSwiperImg',
			indexNav: 'mainIndex/getIndexNav',
			refreshToken: 'common/getRefreshToken',
			siteUrl: 'common/getSiteurl'
		})
	},
	watch: {
		refreshToken: {
			handler: function (val) {
				if (!val) {
					// this.initIndex();
				}
			},
			immediate: true
		}
	},
	data() {
		return {
			loadingHistory: true,
			showPicker: false,
			icon1: require('../../assets/img/study/icon-1.png'),
			icon2: require('../../assets/img/study/icon-2.png'),
			courseData: [],
			columns: ['杭州', '宁波', '温州', '嘉兴', '湖州'],
			modulelist:[]
		};
	},
	created() {
		this.initIndex();
	},
	methods: {
		setSourceUrl,
		initIndex() {
			this.getSwiperlist();
			this.getbook();
			this.getversionlist();
			this.getmodulelist()
		},
		getmodulelist() {
			this.$api.getmodulelist().then((res) => {
				this.modulelist = res.data;
			});
		},
		getSwiperlist() {
			this.$api.getbannerlist().then((res) => {
				this.$store.commit('mainIndex/setSwiperImg', res.data);
			});
		},
		swiperDetail(url, title) {
			if (url) {
				this.$router.push({
					path: '/webView',
					query: {
						webUrl: url,
						title: title
					}
				});
			}
		},
		getbook() {
			this.$api.getbook().then((res) => {
				this.courseData = res.data;
			});
		},getversionlist() {
			this.$api.getversionlist().then((res) => {
				for (let i = 0; i < res.data.length; i++) {
					res.data[i].text = res.data[i].name
				}
				this.columns = res.data;
			});
		},
		setversion(id){
			this.$api.setversion({versionid:id}).then((res) => {
				if(res.code == 1){
					this.getbook()
				}
			});
		},
		onChange(value) {
			this.setversion(value.id);
			this.initIndex();
			this.showPicker = false;
		},
		moduleNav(item){
			this.$api.getmodulechapterlist({moduleid:item.id}).then((res) => {
				if(res.code == 1){
					// this.getbook()
				}
			});
			this.$router.push({
				path: '/bookContent',
				query: {
					name: '精准备考',
					id: item.id,
					navType:1,
					class:'数学'
				}
			});
		}
	}
};
</script>

<style lang="scss">
.my-swipe {
	.van-swipe__indicators {
		bottom: 0.36rem;
	}
	.van-swipe__indicator {
		width: 0.24rem;
		height: 0.04rem;
		border-radius: 0.02rem;
	}
}
</style>
<style lang="scss" scoped>
.title {
	padding: 0.3rem 0;
	text-align: center;
}
.nothing {
	height: 4rem;
	::v-deep .empty-box {
		height: 100%;
	}
}
.course-nav {
	display: flex;
	justify-content: flex-start;
	align-items: center;
	margin-bottom: 0.55rem;
	li {
		position: relative;
		margin-right: 0.4rem;
		font-size: 0.28rem;
		font-weight: 400;
		color: #909090;
		transition: all 0.3s ease-in;
		&::after {
			position: absolute;
			left: 50%;
			bottom: -0.15rem;
			height: 0.04rem;
			width: 0.24rem;
			content: '';
			background: #28b396;
			border-radius: 0 02rem;
			opacity: 0;
			transition: all 0.3s ease-in;
			transform: translateX(-50%);
		}
		&::before {
			position: absolute;
			left: 0;
			right: 0;
			z-index: 2;
			bottom: -0.05rem;
			height: 0.1rem;
			content: '';
			background: #fff;
		}
		&.active {
			position: relative;
			font-weight: 500;
			font-size: 0.28rem;
			color: #28b396;
			&::after {
				opacity: 1;
			}
		}
	}
}
.course-learn {
	padding: 0.24rem 0.28rem 0;
	width: calc(100% - 0.56rem);
	margin-left: 0.28rem;
	background: linear-gradient(0deg, #fff9f6, #ffe3d4);
	border-radius: 0.12rem;
	.item-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 0.27rem;
		.header-left {
			display: flex;
			align-items: center;
			font-size: 0.32rem;
			font-weight: 500;
			color: #333;
			.iconfont {
				font-size: 0.42rem;
				color: #0bbda8;
				margin-right: 0.18rem;
			}
		}
		.header-right {
			display: flex;
			align-items: center;
			font-size: 0.24rem;
			color: #909090;
			font-weight: 400;
			.iconfont {
				font-size: 0.24rem;
				transform: rotate(180deg);
			}
		}
	}
}
.banner-box {
	padding: 0 0.28rem;
	margin-bottom: 0.1rem;
}
.notify {
	display: flex;
	justify-content: flex-start;
	align-items: center;
	margin: 0 0.28rem;
	padding: 0 0.2rem;
	height: 0.72rem;
	margin-bottom: 0.47rem;
	background: #f8f8f8;
	border-radius: 4px;
	.notify-icon {
		width: 1.04rem;
		height: 0.34rem;
		margin-right: 0.22rem;
	}
	.notify-con {
		width: calc(100vw - 2rem);
	}
	.notify-swipe {
		width: 100%;
		height: 0.72rem;
	}
	.notify-text {
		font-size: 0.26rem;
		line-height: 0.72rem;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}
}
.main-nav {
	padding: 0 0.28rem;
	li {
		width: 30%;
		display: flex;
		justify-content: space-between;
	
		margin-bottom: 0.27rem;
		padding: 0.1rem 0;
		&:active {
			background: rgba(0, 0, 0, 0.02);
		}
		.nav-icon {
			width: 100%;
			// height: 1.13rem;
		}
		.nav-text {
			font-size: 0.26rem;
		}
	}
}
.my-swipe {
	margin-bottom: 0.02rem;
	.van-swipe-item {
		height: 3.92rem;
	}

	.swiper-img {
		margin: 0.28rem;
		height: 3.38rem;
		overflow: hidden;
		.img {
			width: 100%;
			height: 3.38rem;
		}
	}
}
</style>
